import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import { scroller } from 'react-scroll';
import {
  SectionName, buildPlxData, SmallButton,
} from '../common/styles';
import {
  BaseContainer, BaseDesc, BaseTitle,
} from './styles';

const Container = styled.div`
  width: 100vw;
  max-width: 100vw;
  margin: auto;

  ${props => (props.theme.isMobile ? `
    background-image: url(${props.theme.linearGradientMobileImage});
    background-size: cover;
    background-position: center;
  ` : `
    background: linear-gradient(-100.09deg, rgba(253, 255, 255, 0.5) 47.62%, rgba(255, 255, 255, 0.5) 54.33%, rgba(144, 237, 255, 0.5) 122.74%), linear-gradient(100.09deg, rgba(253, 255, 255, 0.5) 47.62%, rgba(255, 255, 255, 0.5) 54.33%, rgba(144, 237, 255, 0.5) 122.74%);
  `)};
`;

const InnerContainer = styled(BaseContainer)`
  margin-top: ${props => (props.theme.isMobile ? '32px' : '72px')};
  margin-bottom: ${props => (props.theme.isMobile ? '32px' : '72px')};
  flex-direction: ${props => (props.theme.isMobile ? 'column-reverse' : 'row')};
`;

const Image = styled(Img)`
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    max-width: 560px;
    width: 44vw;
  `)};
`;

const SectionNameExt = styled(SectionName)`
  color: ${props => props.theme.bodyColor};
  font-size: 16px;
`;

const BaseDescExt = styled(BaseDesc)`
  a {
    color: #1E58CF;
    text-decoration: underline;
  }
`;

const Button = styled(SmallButton)`
  background-color: #374662;
  margin-top: 8px;
  width: 170px;

  &:hover {
    background-color: #BDC8DB;
  }
`;

export default function Solutions() {
  const { solutionsImage, isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#solutions', 0);

  const scrollToGetInTouchForm = () => scroller.scrollTo('get_in_touch', {
    duration: 1500,
    smooth: 'easeInOutQuint',
  });

  return (
    <Container id="solutions">
      <InnerContainer>
        <Plx className="left-section" parallaxData={plxData.image} disabled={isMobile}>
          <Image src={solutionsImage} />
        </Plx>
        <Plx className="base-section" parallaxData={plxData.text} disabled={isMobile}>
          <SectionNameExt>Solutions</SectionNameExt>
          <BaseTitle>Proven high performing solutions</BaseTitle>
          <BaseDescExt>
            We can deliver your message to an engaged audience of investment decision-makers.
          </BaseDescExt>
          <BaseDescExt>
            <b>Campaign Activation:</b>
            &nbsp;Get your brand message to your target audience. Across our Websites,
            eNewsletters, Shows and Events, we offer a unique set of trusted media that
            help you build brand awareness and extend your reach with your target audiences.
          </BaseDescExt>
          <BaseDescExt>
            <b>Premium Content:</b>
            &nbsp;Tell your unique story and capture your value. We work with leading companies,
            creating captivating content that tells their unique stories, cutting through the
            noise and generating genuine engagement.
          </BaseDescExt>
          <Button onClick={scrollToGetInTouchForm}>Get In Touch</Button>
        </Plx>
      </InnerContainer>
    </Container>
  );
}
